import { IAppReduxState } from 'shared/types/app';

export function selectScale(state: IAppReduxState): number {
  return state.Scale.scale;
}
